import dayjs from "dayjs";
import { useEffect, useRef } from "react";
import { useAppDispatch, useAppSelector } from "../../../util/hooks";
import { setTitle } from "../../../redux/slices/configuracoes/configuracoesSlice";
import { buscarEmpresa } from "../../../services/empresaService";
import { Col, Form, Row, Select, Image, DatePicker, Button, DatePickerProps, Tooltip, Flex } from "antd";
import { FileExcelOutlined, PrinterOutlined, RedoOutlined } from "@ant-design/icons";
import { useReactToPrint } from "react-to-print";
import { setBuscaRelatorioCreditosConsignatario } from "../../../redux/slices/relatorio/relatorioSlice";
import { gerarRelatorioCreditosConsignatario } from "../../../services/relatorioService";
import { CreditosConsignatariosModal } from "../../../models/relatorio/creditosConsignatariosModal";
import Table, { ColumnsType } from "antd/es/table";
import { currencyBRL } from "../../../util/dinheiroBRAuxiliar";
import React from "react";
import { EmpresaModel } from "../../../models/empresa/empresaModel";
import * as XLSX from "xlsx";
import { BuscarRelatorioCreditosConsignatarioModel } from "../../../models/relatorio/buscarRelatorioCreditosConsignatarioModel";
import TableComponent from "../../../components/table/tableComponent";

dayjs.locale("pt-br");

const CreditosConsignatariosRelatorio = () => {
  //estados globais
  const empresaState = useAppSelector((state) => state.empresa);
  const relatorioState = useAppSelector((state) => state.relatorio);
  const persistedState = useAppSelector((state) => state.persisted);

  //hooks
  const dispatch = useAppDispatch();

  //estados locais
  const [form] = Form.useForm();
  const relatorioCreditosConsignatario = useRef<HTMLDivElement>(null);

  useEffect(() => {
    dispatch(setTitle("RELATÓRIO DE CRÉDITOS DOS CONSIGNATÁRIOS"));
    if (persistedState.user.empresa !== null) {
      onChangeEmpresa(persistedState.user.empresa.idEmpresa);
    }
    dispatch(buscarEmpresa(empresaState.busca));
    form.setFieldsValue({
      dataInicio: dayjs(relatorioState.buscaCreditosConsignatario.dataInicio),
      dataFim: dayjs(relatorioState.buscaCreditosConsignatario.dataFim),
    });
  }, []);

  const onChangeEmpresa = (value: number) => {
    let busca: BuscarRelatorioCreditosConsignatarioModel = { ...relatorioState.buscaCreditosConsignatario, idEmpresa: value };

    dispatch(setBuscaRelatorioCreditosConsignatario(busca));
    dispatch(gerarRelatorioCreditosConsignatario(busca));
  };

  const onChangeDateInicio = (value: DatePickerProps["value"], dateString: string | string[]) => {
    let busca: BuscarRelatorioCreditosConsignatarioModel = { ...relatorioState.buscaCreditosConsignatario, dataInicio: dayjs(value).toDate() };

    dispatch(setBuscaRelatorioCreditosConsignatario(busca));
    dispatch(gerarRelatorioCreditosConsignatario(busca));
  };

  const onChangeDateFim = (value: DatePickerProps["value"], dateString: string | string[]) => {
    let busca: BuscarRelatorioCreditosConsignatarioModel = { ...relatorioState.buscaCreditosConsignatario, dataFim: dayjs(value).toDate() };

    dispatch(setBuscaRelatorioCreditosConsignatario(busca));
    dispatch(gerarRelatorioCreditosConsignatario(busca));
  };

  const atualizar = () => {
    dispatch(gerarRelatorioCreditosConsignatario(relatorioState.buscaCreditosConsignatario));
  };

  const handlePrint = useReactToPrint({
    content: () => relatorioCreditosConsignatario.current,
  });

  const handleExcel = () => {
    var data: any = [];

    data.push({
      "Filtro Empresa": empresaState.list.filter((a: EmpresaModel) => a.id === relatorioState.buscaCreditosConsignatario.idEmpresa)[0]?.apelido,
    });

    data.push({
      "Filtro Empresa": "Filtro Data Inicial",
    });
    data.push({
      "Filtro Empresa": dayjs(relatorioState.buscaCreditosConsignatario.dataInicio).format("DD/MM/YYYY"),
    });

    data.push({
      "Filtro Empresa": "Filtro Data Final",
    });
    data.push({
      "Filtro Empresa": dayjs(relatorioState.buscaCreditosConsignatario.dataFim).format("DD/MM/YYYY"),
    });

    data.push({
      "Filtro Empresa": "Consignatário",
      "": "Data",
      " ": "Valor",
    });

    relatorioState.listCreditosConsignatario.forEach((item: CreditosConsignatariosModal) => {
      data.push({
        "Filtro Empresa": item.consignatario,
        "": dayjs(item.data).format("DD/MM/YYYY"),
        " ": currencyBRL(item.valorTransacao),
      });
    });

    data.push({
      "Filtro Empresa": "Valor Total",
    });
    data.push({
      "Filtro Empresa": currencyBRL(somatorio.valorTransacao),
    });

    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, "CreditosConsignatários.xlsx");
  };

  const somatorio = relatorioState.listCreditosConsignatario.reduce(
    (acumulador, conta) => {
      acumulador.valorTransacao += conta.valorTransacao || 0;
      return acumulador;
    },
    {
      valorTransacao: 0,
    }
  );

  const RelatorioHtml = React.forwardRef<HTMLDivElement>((_props, ref) => {
    return (
      <>
        <div ref={ref} className="relatorios-html-format">
          <div className="rel-cabecalho">
            <div className="rel-titulo">
              <h2>
                <strong>Créditos dos consignatários</strong>
              </h2>
            </div>
            <hr />
            <p>
              {"Empresa: " +
                empresaState.list.filter((a: EmpresaModel) => a.id === relatorioState.buscaCreditosConsignatario.idEmpresa)[0]?.apelido +
                "; Data: " +
                dayjs(relatorioState.buscaCreditosConsignatario.dataInicio).format("DD/MM/YYYY") +
                " " +
                "até " +
                dayjs(relatorioState.buscaCreditosConsignatario.dataFim).format("DD/MM/YYYY")}
            </p>
          </div>
          <div className="rel-detalhes">
            <table className="tb-dados">
              <thead>
                <tr className="header-table">
                  <th className="ht-left">Consignatário</th>
                  <th className="ht-right">Valor</th>
                </tr>
              </thead>
              <tbody className="body-table">
                {relatorioState.listCreditosConsignatario.map((t) => {
                  return (
                    <React.Fragment key={t.id}>
                      <tr>
                        <td className="ht-left">{t.consignatario}</td>
                        <td className="ht-right">{currencyBRL(t.valorTransacao)}</td>
                      </tr>
                    </React.Fragment>
                  );
                })}
              </tbody>
              <tfoot className="footer-table">
                <tr>
                  <td className="ht-left">VALOR TOTAL:</td>
                  <td className="ht-right">{currencyBRL(somatorio.valorTransacao)}</td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </>
    );
  });

  const columns: ColumnsType<CreditosConsignatariosModal> = [
    {
      title: "CONSIGNATÁRIO",
      dataIndex: "consignatario",
    },
    {
      title: "VALOR",
      dataIndex: "valorTransacao",
      align: "right",
      render: (_, record) =>
        record.valorTransacao !== null &&
        (record.valorTransacao < 0 ? (
          <p style={{ color: "red", marginBottom: "0px" }}>{currencyBRL(record.valorTransacao)}</p>
        ) : (
          <p style={{ color: "blue", marginBottom: "0px" }}>{currencyBRL(record.valorTransacao)}</p>
        )),
    },
  ];

  return (
    <Flex vertical>
      <Form layout="vertical" form={form}>
        <Row gutter={12} align="bottom">
          <Col span={20}>
            <Flex gap={12}>
              {persistedState.user.empresa === null && (
                <Form.Item
                  label="Empresa"
                  name="empresa"
                  rules={[
                    {
                      required: true,
                      message: "Selecione uma empresa",
                    },
                  ]}
                >
                  <Select
                    showSearch
                    optionFilterProp="labelSearch"
                    loading={empresaState.loading}
                    onChange={onChangeEmpresa}
                    style={{ width: 300 }}
                    options={empresaState.list.map((a: EmpresaModel) => ({
                      value: a.id,
                      key: a.apelido,
                      label: (
                        <Flex justify="flex-start" align="center" gap={8} style={{ padding: "1px 0px" }}>
                          <Flex style={{ lineHeight: "0px" }}>{a.urlLogotipoPequeno && <Image width={25} height={25} style={{ lineHeight: "0px" }} src={a.urlLogotipoPequeno} preview={false} />}</Flex>
                          {a.apelido}
                        </Flex>
                      ),
                      labelSearch: a.apelido,
                    }))}
                  />
                </Form.Item>
              )}
              <Form.Item label="Data início" name="dataInicio">
                <DatePicker placeholder="" onChange={onChangeDateInicio} format="DD/MM/YYYY" style={{ width: 120 }} />
              </Form.Item>
              <Form.Item label="Data fim" name="dataFim">
                <DatePicker placeholder="" onChange={onChangeDateFim} format="DD/MM/YYYY" style={{ width: 120 }} />
              </Form.Item>
              <Form.Item label=" ">
                <Tooltip title="Atualizar">
                  <Button icon={<RedoOutlined />} className="buttonPrimary" style={{ minHeight: 32 }} onClick={atualizar} />
                </Tooltip>
              </Form.Item>
            </Flex>
          </Col>
          <Col span={4}>
            <Flex justify="end" gap={12}>
              <Form.Item name="botaoCarregar" label=" ">
                <Button icon={<PrinterOutlined />} onClick={handlePrint} disabled={relatorioState.loadingCreditosConsignatario}></Button>
              </Form.Item>
              <Form.Item name="botaoCarregar" label=" ">
                <Button icon={<FileExcelOutlined />} onClick={handleExcel} disabled={relatorioState.loadingCreditosConsignatario}></Button>
              </Form.Item>
            </Flex>
          </Col>
        </Row>
      </Form>
      <TableComponent
        columns={columns}
        data={relatorioState.listCreditosConsignatario}
        loading={relatorioState.loadingCreditosConsignatario}
        tableProps={{
          summary: (pageData: any) =>
            pageData.length > 0 && (
              <Table.Summary.Row className="rowFooterCls">
                <Table.Summary.Cell index={0}>VALOR TOTAL:</Table.Summary.Cell>
                <Table.Summary.Cell index={1} align="right">
                  <span style={{ color: somatorio.valorTransacao > 0 ? "blue" : "red", marginBottom: "0px" }}>{currencyBRL(somatorio.valorTransacao)}</span>
                </Table.Summary.Cell>
              </Table.Summary.Row>
            ),
        }}
      />
      <div style={{ display: "none" }}>
        <RelatorioHtml ref={relatorioCreditosConsignatario}></RelatorioHtml>
      </div>
    </Flex>
  );
};

export default CreditosConsignatariosRelatorio;
